import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import * as constants from '../../../common/constants';

const TenantFeatureData = types.model('TenantFeatureData', {
  name: types.union(types.string, types.boolean),
  value: types.union(types.string, types.boolean),
  key: types.maybeNull(types.string),
  comment: types.maybeNull(types.string),
  overridden: types.maybeNull(types.string)
});

const TenantFeatureModel = types
  .model('TenantFeatureModel', {
    data: types.optional(types.array(TenantFeatureData), [])
  })
  .actions((self) => ({
    fetch(tenantId) {
      Framework.getEventManager().publish(constants.GET_TENANT_FEATURE_DATA, {
        tenantId
      });
    },
    updateTenantFeature(payload, tenantId) {
      Framework.getEventManager().publish(constants.UPDATE_TENANT_FEATURE_DATA, {
        payload,
        tenantId
      });
    },
    addTenantFeature(payload, tenantId) {
      Framework.getEventManager().publish(constants.ADD_TENANT_FEATURE_DATA, {
        payload,
        tenantId
      });
    },
    setResponse(response) {
      const finalData = {};
      finalData.data = response.data.map((item) => ({
        ...item,
        overridden: item.tenantId !== '0' ? constants.YES_BOOL.toUpperCase() : constants.NO_BOOL.toUpperCase()
      }));
      applySnapshot(self, finalData);
      Framework.getEventManager().publish(constants.SET_TENANT_FEATURE_DATA);
    },

    setUpdatedTenantFeature(response) {
      if (response.data.recordsUpserted > 0) {
        const tenantId = response?.config?.headers[constants.BERLIN_TENANT_ID_HEADER];
        Framework.getEventManager().publish(constants.GET_TENANT_FEATURE_DATA, {
          tenantId
        });
      }
    },

    setAddedTenantFeature(response) {
      if (response?.data?.success === false) {
        return;
      }

      const tenantId = response?.config?.headers?.[constants.BERLIN_TENANT_ID_HEADER];
      if (tenantId) {
        Framework.getEventManager().publish(constants.GET_TENANT_FEATURE_DATA, {
          tenantId
        });
      }
    }
  }));

export default TenantFeatureModel;
